export const SubStatusEnum = {
  NORMAL: 0,
  EXPIRED: 1,
  EXPIRED_AGGREGATOR: 2,
  REJECTED_AGGREGATOR: 3,
  REFUNDED: 4,
  REFUNDED_AGGREGATOR: 5,
};
